export class IPRfilterModel {
  pageNumber?: string;
  pageSize?: string;
  whereCondition?: string;
  orderBy?: string;
  keywordFilter?: string;
  stateID?: string;
  userID?: string;
  columnIndex?: string;
  productId?: number;
  actionTypes?: string;
  carrierCategories?: string;
  actionSatus?: string;
  listOfProduct?: string;
  emailKey?: string;
  isActionRequired?: boolean; 
  oprator?: string;
  fromDate?: string;
  toDate?: string;
  listOfType?: string;
  systemUserCondition?: string;
}

export class IPRcarrierFilterModel {
  orderBy: string;
  keywordFilter: string;
  fromDate: string;
  todate: string;
  updateStatus: string;
  userID: number;
  ID: number;
  Status: number;
  filterFavourite: number;
  newCarrierID: number;
  carrierFilter: string;
}

export class IPRcarrierFilterModelV2 {
  orderBy: string;
  keywordFilter: string;
  fromDate: string;
  todate: string;
  updateStatus: string;
  userID: number;
  ID: number;
  Status: number;
  filterFavourite: number;
  newCarrierID: number;
  carrierFilter: string;
  pageNumber:number;
  pageSize:number;
}